import { compareDesc } from 'date-fns';
import apiManager from '../../api/api-manager';
import { parseServerDateTime } from '../../api/parsers/commons-api-parsers';
import { parseNewsItem } from '../../api/parsers/news-api-parsers';
import { News } from '../../model';
import { NewsDownloadError } from '../../store';
import { AsyncThunkConfig } from '../../store/async-thunk-config';
import { getAPIRequestHeaders, GetThunkAPI } from '../../utils/api-utils';
import { NewsRepository } from './news-repository';

export const papyrusNewsRepository: NewsRepository = {
  getNewsList: async (
    thunkApi: GetThunkAPI<AsyncThunkConfig<NewsDownloadError>>
  ): Promise<News[]> => {
    const response =
      await apiManager.azDocumentProviderApi.searchDocumentsByFilter1(
        undefined,
        {
          documentTypes: ['NEWS'],
        },
        getAPIRequestHeaders(thunkApi)
      );
    return response.data.result
      .filter(
        (a) =>
          a?.expirationDate === undefined ||
          parseServerDateTime(a.expirationDate) >= new Date(Date.now())
      )
      .sort((a, b) =>
        compareDesc(
          parseServerDateTime(a.creationDate),
          parseServerDateTime(b.creationDate)
        )
      )
      .map(parseNewsItem);
  },
};
